export const es = {
  // Common
  "common.back": "Volver",
  "common.cancel": "Cancelar",
  "common.noItems": "No hay elementos",
  "common.loading": "Cargando...",
  
  // Header
  "nav.features": "Características",
  "nav.howItWorks": "Cómo funciona",
  "nav.pricing": "Precios",
  "nav.faq": "Preguntas frecuentes",
  "nav.testimonials": "Vitrina",
  "nav.contact": "Contacto",
  "button.getStarted": "Comenzar",
  "button.loading": "Cargando...",

  // Auth related
  "auth.signIn": "Iniciar Sesión",
  "auth.redirecting": "Redirigiendo...",
  "auth.continueWithGoogle": "Continuar con Google",
  "auth.continueWithGithub": "Continuar con GitHub",
  "auth.or": "O",
  "auth.consent.prefix": "Al continuar, aceptas nuestros",
  "auth.consent.terms": "Términos",
  "auth.consent.and": "y",
  "auth.consent.privacy": "Política de Privacidad",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜", // 中文标题

  // Hero Section
  "hero.title": "Asistente de Comunicación con IA",
  "hero.subtitle": "Transforma tus conversaciones con respuestas inteligentes y conscientes del contexto que te ayudan a comunicarte de manera más efectiva en cualquier situación.",
  "hero.cta.primary": "Prueba Gratuita",
  "hero.cta.secondary": "Ver Demo",
  // New Hero Showcase keys
  "hero.cta.tryNow": "Comenzar gratis",
  "hero.cta.learnMore": "Aprender más",
  "hero.cta.getStarted": "Comenzar gratis",
  "hero.preview.primary": "Pulir el tono",
  "hero.preview.secondary": "Traducir",
  "hero.preview.tone": "Amigable",
  "hero.preview.target": "Cliente",
  "hero.hook": "Únete a miles de usuarios que mejoran su comunicación todos los días.",
  // Stats
  "stats.users": "Usuarios",
  "stats.replies": "Respuestas",
  "stats.languages": "Idiomas",

  // Main Title
  "main.title": "Convierte Cada Respuesta en una Oportunidad",

  // Footer Section - 新增
  "footer.company": "Empresa",
  "footer.product": "Producto",
  "footer.support": "Soporte",
  "footer.legal": "Legal",
  "footer.contactSupport": "Contactar Soporte",
  "footer.helpCenter": "Centro de Ayuda",
  "footer.apiDocs": "Documentación API",
  "footer.statusPage": "Estado del Servicio",
  "footer.privacyPolicy": "Política de Privacidad",
  "footer.termsOfService": "Términos de Servicio",
  "footer.cookiePolicy": "Política de Cookies",
  "footer.refundPolicy": "Política de Reembolso",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Soporte",

  // Features Section
  "features.badge": "Características Poderosas",
  "features.title": "Todo lo que Necesitas para una Mejor Comunicación",
  "features.subtitle": "Herramientas integrales diseñadas para hacer cada conversación más efectiva y profesional.",
  "features.scenario.title": "Plantillas de Escenarios",
  "features.scenario.description": "Plantillas prediseñadas para comunicaciones laborales, personales, académicas y profesionales.",
  "features.custom.title": "Entradas Personalizadas",
  "features.custom.description": "Pega cualquier mensaje o contenido y obtén respuestas contextualmente apropiadas.",
  "features.instant.title": "Reducir el tiempo de respuesta en un 90%",
  "features.instant.description": "Obtén respuestas elaboradas por IA en pocos segundos. Sin esperas, solo resultados.",
  "features.copy.title": "Copiar y Compartir con Un Clic",
  "features.copy.description": "Copia respuestas al instante o compártelas directamente desde la plataforma.",

  // How It Works Section
  "howItWorks.badge": "Cómo Funciona",
  "howItWorks.title": "Tres Pasos Simples para una Mejor Comunicación",
  "howItWorks.subtitle": "Nuestro proceso simplificado facilita generar respuestas profesionales para cualquier situación.",
  "howItWorks.step1.title": "Seleccionar Escenario",
  "howItWorks.step1.description": "Elige el escenario de comunicación que mejor se adapte a tus necesidades.",
  "howItWorks.step2.title": "Pegar Contenido",
  "howItWorks.step2.description": "Agrega el mensaje o contenido al que necesitas responder.",
  "howItWorks.step3.title": "Obtener Respuesta IA",
  "howItWorks.step3.description": "Recibe una respuesta profesional y contextual en segundos.",

  // Pricing Section
  "pricing.title": "Precios",
  "pricing.subtitle": "Elige el plan que se adapte a tus necesidades de comunicación",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/mes",
  "pricing.free.description": "Perfecto para probar nuestro servicio",
  "pricing.pro.description": "Ideal para profesionales y usuarios frecuentes",
  "pricing.business.description": "Para equipos y organizaciones",
  "pricing.popular": "Más Popular",
  "pricing.free.feature1": "10 respuestas por mes",
  "pricing.free.feature2": "Escenarios básicos",
  "pricing.free.feature3": "Definir y usar plantillas",
  "pricing.free.feature4": "Registro de respuesta histórica",
  "pricing.pro.feature1": "200 respuestas por mes",
  "pricing.pro.feature2": "Escenario básico + personalizado",
  "pricing.pro.feature3": "Definir y usar plantillas",
  "pricing.pro.feature4": "Registro de respuesta histórica",
  "pricing.pro.feature5": "Personalización avanzada",
  "pricing.business.feature1": "Respuestas ilimitadas",
  "pricing.business.feature2": "Colaboración en equipo",
  "pricing.business.feature3": "Escenario básico + personalizado",
  "pricing.business.feature4": "Definir y usar plantillas",
  "pricing.business.feature5": "Registro de respuesta histórica",
  "pricing.business.feature6": "Personalización avanzada",
  "pricing.cta.trial": "Comenzar Prueba Gratuita",
  "pricing.cta.subscribe": "Suscribirse",
  "pricing.cta.contact": "Contactar Ventas",
  "pricing.cta.current": "Plan Actual",
  "pricing.currentPlan": "Plan Actual:",
  "pricing.endDate": "Fecha de finalización del plan actual:",
  "pricing.autoRenewalDate": "Fecha de renovación automática del plan actual:",
  "pricing.answersLeft": "Respuestas restantes:",
  "pricing.planName.free": "Plan Free",
  "pricing.planName.proMonthly": "Plan Pro-Mensual",
  "pricing.planName.proYearly": "Plan Pro-Anual",
  "pricing.planName.maxMonthly": "Plan Enterprise-Mensual",
  "pricing.planName.maxYearly": "Plan Enterprise-Anual",
  "pricing.autoRenews": "Su conteo de respuestas se renueva automáticamente el:",
  "pricing.needMore": "¿Necesita más respuestas?",
  "pricing.upgradeBelow": "Actualice su plan a continuación",
  "pricing.doNotRollOver": "Las respuestas no usadas no se acumulan",
  "pricing.willCancelOn": "Se cancelará el:",
  "pricing.downgradeScheduled": "Degradación programada. Cambiará a",
  "pricing.on": "el:",
  "pricing.upgradeImmediateTitle": "Plan actualizado",
  "pricing.upgradeImmediateDesc": "Su nuevo plan ahora está activo.",
  "pricing.downgradeScheduledTitle": "Degradación programada",
  "pricing.downgradeScheduledDesc": "Su plan cambiará en el próximo periodo de renovación.",
  "pricing.cancelScheduledTitle": "Cancelación programada",
  "pricing.cancelScheduledDesc": "Su plan finalizará en la fecha de finalización del periodo.",
  "pricing.cancelResumedTitle": "Cancelación eliminada",
  "pricing.cancelResumedDesc": "Su suscripción continuará renovándose.",
  "pricing.cancelPendingDowngrade": "Cancelar",
  "pricing.pendingDowngradeCanceledTitle": "Degradación pendiente cancelada",
  "pricing.pendingDowngradeCanceledDesc": "Su plan permanecerá sin cambios.",
  "pricing.pendingDowngradeCancelFailedTitle": "Error al cancelar",
  "pricing.pendingDowngradeCancelFailedDesc": "No se pudo cancelar la degradación pendiente. Por favor, inténtelo de nuevo.",
  "pricing.cancelPendingDowngradeProcessing": "Procesando...",
  "pricing.scheduled": "Programado",
  "pricing.processing": "Procesando...",
  "pricing.getMoreReplies": "Obtener más respuestas",
  "pricing.oneTimeTitle": "Obtener más respuestas para su cuenta",
  "pricing.oneTimeAmountLabel": "Importe (USD)",
  "pricing.repliesUnit": "Respuestas",
  "pricing.oneTimeNotice": "El número de respuestas que compra es válido para el ciclo mensual actual. Se requiere una suscripción de pago activa para usarlas y las respuestas no utilizadas no se acumulan.",
  "pricing.cancel": "Cancelar",
  "pricing.proceed": "Continuar",
  "pricing.confirmUpgradeTitle": "Confirmar actualización",
  "pricing.confirmDowngradeTitle": "Confirmar degradación",
  "pricing.confirmUpgradeDesc": "Está a punto de actualizar su plan. El cambio entra en vigor inmediatamente y puede aplicarse un cargo (o crédito) prorrateado.",
  "pricing.confirmDowngradeDesc": "Está a punto de programar una degradación. Sus funciones actuales permanecen hasta el final del periodo de facturación actual.",
  "pricing.downgradeEffectNote": "La degradación no reembolsa el ciclo actual.",
  "pricing.downgradeApplyNextCycle": "El nuevo plan se iniciará automáticamente en la renovación.",
  "pricing.confirmCancel": "Volver",
  "pricing.confirmProceedUpgrade": "Actualizar ahora",
  "pricing.confirmProceedDowngrade": "Programar degradación",

  // FAQ Section
  "faq.title": "Preguntas Frecuentes",
  "faq.subtitle": "Todo lo que necesitas saber sobre communicate2win",
  "faq.q1": "¿Qué escenarios de comunicación son compatibles?",
  "faq.a1": "Admitimos comunicaciones laborales, relaciones personales, correspondencia académica, servicio al cliente, alcance de ventas y muchos otros escenarios. Nuestra IA se adapta al contexto y tono requerido para cada situación.",
  "faq.q2": "¿Qué tan rápido se generan las respuestas?",
  "faq.a2": "Nuestra IA genera respuestas en pocos segundos. Priorizamos la velocidad sin comprometer la calidad, asegurando que obtengas respuestas profesionales al instante.",
  "faq.q3": "¿Puedo cancelar mi suscripción en cualquier momento?",
  "faq.a3": "Sí, puedes cancelar tu suscripción en cualquier momento. No hay compromisos a largo plazo, y puedes degradar o actualizar tu plan según sea necesario.",
  "faq.q4": "¿Mis datos están seguros y son privados?",
  "faq.a4": "Sí, implementamos medidas de seguridad integrales que incluyen cifrado, controles de acceso y auditorías de seguridad regulares. Tu contenido de entrada y las respuestas generadas se almacenan como parte de tu historial de usuario para habilitar funciones como revisión de respuestas y creación de plantillas. Puedes eliminar tus datos de historial en cualquier momento a través de la configuración de tu cuenta.",
  "faq.q5": "¿Qué pasa si me quedo sin Replies?",
  "faq.a5": "Los usuarios Free deben esperar hasta el próximo ciclo mensual para que se renueve su cuota. Tras actualizar a Pro, si se te acaban las Replies puedes comprar paquetes adicionales de una sola vez; estas Replies extra solo son válidas durante el ciclo mensual actual. Los usuarios Enterprise tienen Replies ilimitadas.",
  "faq.q6": "¿Qué idiomas son compatibles?",
  "faq.a6": "Actualmente, admitimos inglés con planes de expandir a español, francés, alemán y otros idiomas principales. La IA puede manejar comunicaciones multilingües de manera efectiva.",
  
  // Testimonials Section
  "testimonials.title": "Vitrina de Comunicaciones",
  "testimonials.subtitle": "Mensajes públicos, correos electrónicos y respuestas perfeccionadas con IA para inspirar las tuyas",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Directora de Marketing",
  "testimonials.sarah.quote": "communicate2win ha transformado cómo manejo las comunicaciones con clientes. Las respuestas son profesionales y me ahorran horas cada semana.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Gerente de Ventas",
  "testimonials.michael.quote": "Las plantillas de escenarios laborales son increíblemente precisas. Mi tasa de respuesta ha mejorado un 40% desde que uso esta herramienta.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Líder de Éxito del Cliente",
  "testimonials.emily.quote": "Perfecto para manejar situaciones difíciles con clientes. La IA entiende el contexto y el tono perfectamente.",
  "testimonials.more": "Haz clic en la galería para explorar toda la vitrina",

  // Interface Elements
  "interface.generating": "Generando Respuesta...",
  "interface.generate": "Generar Respuesta IA",
  "interface.processing": "Procesando...",
  "interface.advancedOptions": "Opciones Avanzadas",
  "interface.clearInput": "Limpiar Entrada",
  "interface.clearDescription": "Limpiar Descripción",
  // Marquee / Logos
  "marquee.trusted": "Socios / Soporte",
  "marquee.aria": "Logos de marcas",

  // History and Showcase
  "history.shareToShowcase": "Compartir en Vitrina",
  "history.showcased": "En vitrina",
  "history.shareConfirm": "Confirma que desea compartir esta publicación en la Vitrina? Esta acción no se puede deshacer salvo que elimine la publicación.",
  "history.sharedBy": "Compartido por:",
  "interface.copy": "Copiar",
  "interface.share": "Compartir",
  "interface.shareResponse": "Compartir Respuesta",
  "interface.shareNative": "Compartir por Sistema",
  "interface.shareEmail": "Correo",
  "interface.copyShareText": "Copiar con Enlace",
  "interface.shareTextCopied": "Respuesta y enlace copiados al portapapeles.",
  "interface.ready": "Listo para Generar",
  "interface.enterMessage": "Ingresa el contenido de tu mensaje y selecciona un escenario para comenzar con respuestas impulsadas por IA.",
  "interface.fast": "Rápido",
  "interface.accurate": "Preciso",
  "interface.professional": "Profesional",
  "interface.translation": "Traducción",
  "interface.responseDescription": "Aquí hay una respuesta reflexiva y profesional adaptada al contexto:",
  "interface.multipleOptions": "Varias opciones de respuesta:",
  "interface.option": "Opción",
  "interface.noContent": "No hay contenido disponible",

  // Placeholders
  "placeholder.message": "Pega el mensaje al que estás respondiendo, contenido de correo electrónico o texto que recibiste...",

  // Dropdowns
  "dropdown.useTemplates": "Usar plantillas",
  "dropdown.scenario": "Sin Escenario",
  "dropdown.target": "Sin Objetivo",
  "dropdown.tone": "Sin Tono",

  // Scenario Options
  "scenario.email": "Correo",
  "scenario.message": "Mensaje",
  "scenario.workplace": "Trabajo",
  "scenario.school": "Escuela",
  "scenario.home": "Hogar",
  "scenario.business": "Negocios",
  "scenario.academic": "Académico",
  "scenario.social": "Social",
  "scenario.formal": "Formal",
  "scenario.casual": "Casual",
  "scenario.professional": "Profesional",
  "scenario.personal": "Personal",
  "scenario.customerService": "Servicio al Cliente",
  "scenario.interview": "Entrevista",
  "scenario.presentation": "Presentación",

  // Target Options
  "target.lover": "Pareja",
  "target.friend": "Amigo",
  "target.boss": "Jefe",
  "target.colleague": "Colega",
  "target.classmate": "Compañero de clase",
  "target.parents": "Padres",
  "target.child": "Hijo",
  "target.teacher": "Profesor",
  "target.student": "Estudiante",
  "target.client": "Cliente",
  "target.customer": "Cliente",
  "target.stranger": "Desconocido",
  "target.family": "Familia",
  "target.sibling": "Hermano",
  "target.neighbor": "Vecino",
  "target.mentor": "Mentor",
  "target.supplier": "Proveedor",
  "target.serviceProvider": "Proveedor de Servicios",
  "target.partner": "Socio",
  "target.subordinate": "Subordinado",

  // Tone Options
  "tone.humorous": "Divertido",
  "tone.serious": "Serio",
  "tone.happy": "Feliz",
  "tone.angry": "Enojado",
  "tone.mischievous": "Travieso",
  "tone.polite": "Cortés",
  "tone.casual": "Casual",
  "tone.formal": "Formal",
  "tone.friendly": "Amigable",
  "tone.confident": "Confiado",
  "tone.apologetic": "Disculpándose",
  "tone.enthusiastic": "Entusiasta",

  // Status Messages
  "status.copied": "¡Copiado!",
  "status.copyDescription": "Respuesta copiada al portapapeles.",
  "status.copyWithTranslationDescription": "Respuesta y traducción copiadas al portapapeles.",
  "status.success": "Respuesta generada exitosamente. ",
  "status.successWithTranslation": "Respuesta generada con traducción.",
  "status.successWithoutTranslation": "Respuesta generada exitosamente.",
  "status.error": "Generación fallida",
  "status.errorDescription": "Error al generar respuesta. Por favor intenta de nuevo.",
  "status.enterContent": "Por favor ingresa contenido",
  "status.enterContentDescription": "Agrega el mensaje al que quieres responder.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Descripción (opcional)",
  "restriction.descriptionLabel": "Descripción (Solo para suscriptores Pro / Enterprise)",
  "restriction.proMaxOnly": "* Solo para suscriptores Pro / Enterprise",
  "restriction.desPrompt": "Introduce contexto, información de fondo o requisitos específicos que ayuden a generar mejores respuestas...",

  // Demo functionality for non-logged-in users
  "demo.title": "Selecciona un mensaje al que responder",
  "demo.option1": "Apertura de ventas (contacto en frío)",
  "demo.option2": "Manejo de una consulta \"tu precio es alto\"",
  "demo.option3": "Autopresentación en entrevista (versión de 30 segundos)",
  "demo.option4": "Respuesta por correo electrónico",
  "demo.option5": "Seguimiento para un prospecto \"leído pero sin respuesta\"",
  "demo.option6": "Discurso de ascensor (30 segundos)",
  "demo.runDemo": "Ejecutar Demo",
  "demo.inputContent": "Contenido de Entrada:",
  "demo.scenario": "Escenario:",
  "demo.target": "Objetivo:",
  "demo.tone": "Tono:",
  "demo.description": "Descripción:",

  // Showcase Page
  "showcase.title": "Vitrina de Comunicaciones",
  "showcase.subtitle": "Descubre comunicaciones inspiradoras impulsadas por IA compartidas por nuestra comunidad",
  "showcase.userPrefix": "Comunicaciones públicas por",
  "showcase.backAll": "Volver a toda la Vitrina",
  "showcase.sortBy": "Ordenar por:",
  "showcase.sort.newest": "Más recientes primero",
  "showcase.sort.oldest": "Más antiguos primero",
  "showcase.sort.scenario": "Por Escenario",
  "showcase.sort.target": "Por Destino",
  "showcase.sort.tone": "Por Tono",
  "showcase.filter.scenario": "Escenario:",
  "showcase.filter.target": "Destino:",
  "showcase.filter.tone": "Tono:",
  "showcase.filter.all": "Todos",
  "showcase.loading": "Cargando vitrina...",
  "showcase.loadingUser": "Cargando comunicaciones del usuario...",
  "showcase.loadingMore": "Cargando más...",
  "showcase.none.userTitle": "Aún no hay comunicaciones públicas",
  "showcase.none.globalTitle": "Aún no hay elementos en la vitrina",
  "showcase.none.userDesc": "Este usuario aún no ha compartido comunicaciones en la vitrina.",
  "showcase.none.globalDesc": "¡Sé el primero en compartir tu comunicación con IA en la vitrina!",
  "showcase.messageDetails": "Detalles del Mensaje",
  "showcase.field.date": "Fecha",
  "showcase.field.scenario": "Escenario",
  "showcase.field.target": "Destino",
  "showcase.field.tone": "Tono",
  "showcase.originalMessage": "Mensaje Original",
  "showcase.description": "Descripción",
  "showcase.aiResponse": "Respuesta IA",

  // Templates
  "templates.saveAsTemplate": "Guardar como Plantilla",
  "templates.saved": "Plantilla Guardada",
  "templates.saveSuccess": "Plantilla guardada exitosamente",
  "templates.title": "Mis Plantillas",
  "templates.new": "Nueva Plantilla",
  "templates.loading": "Cargando...",
  "templates.none": "No se encontraron plantillas",
  "templates.name": "Nombre",
  "templates.scenario": "Escenario",
  "templates.target": "Destino",
  "templates.tone": "Tono",
  "templates.description": "Descripción",
  "templates.save": "Guardar",
  "templates.saving": "Guardando...",
  "templates.delete": "Eliminar Plantilla",
  "templates.deleteConfirm": "¿Eliminar esta plantilla?",
  "templates.deleteFailed": "Error al eliminar la plantilla",
  "templates.nameRequired": "* Por favor ingrese el nombre de la plantilla",
  "templates.deleteSuccess": "Plantilla eliminada exitosamente",
  "templates.saveFailed": "Error al guardar la plantilla",

  // History Modal additions
  "history.messageDetails": "Detalles del Mensaje",
  "history.messageDetailsDesc": "Ver y gestionar los detalles del mensaje, incluyendo la entrada original y la respuesta generada por IA.",
  "history.field.date": "Fecha",
  "history.field.scenario": "Escenario",
  "history.field.target": "Destino",
  "history.field.tone": "Tono",
  "history.originalMessage": "Mensaje Original",
  "history.aiResponse": "Respuesta IA",
  "history.description": "Descripción",
  "history.listTitle": "Historial de Mensajes",
  "history.listDesc": "Explora, filtra y gestiona tu historial de conversaciones. Haz clic en cualquier mensaje para ver los detalles.",
  "history.sortBy": "Ordenar por:",
  "history.sort.newest": "Más recientes primero",
  "history.sort.oldest": "Más antiguos primero",
  "history.sort.scenario": "Por Escenario",
  "history.sort.target": "Por Destino",
  "history.sort.tone": "Por Tono",
  "history.filter.scenario": "Escenario:",
  "history.filter.target": "Destino:",
  "history.filter.tone": "Tono:",
  "history.filter.all": "Todos",
  "history.loading": "Cargando historial...",
  "history.loadingMore": "Cargando más...",
  "history.none": "No se encontraron mensajes",
  "history.showing": "Mostrando {current} de {total} mensajes",
  "history.allLoaded": "Todos los mensajes cargados",
  "history.scrollMore": "Desplázate hacia abajo para más",
  "history.loadMoreButton": "Cargar Más",
  "history.deleteMessage": "Eliminar Mensaje",
  "history.deleting": "Eliminando...",
  "history.deleteSuccess": "Registro de mensaje eliminado exitosamente",
  "history.deleteFailed": "Error al eliminar el registro del mensaje, por favor inténtalo de nuevo",
  "history.confirmDeleteTitle": "Confirmar Eliminación",
  "history.confirmDeleteSubtitle": "Esta acción no se puede deshacer",
  "history.confirmDeleteDesc": "¿Estás seguro de que quieres eliminar este registro de mensaje?",
  "history.confirmDeleteAction": "Confirmar Eliminación",
  "history.shareTitle": "Compartir en Vitrina",
  "history.shareSubtitle": "Hacer público este mensaje",
  "history.sharing": "Compartiendo...",
  "history.confirmShareAction": "Confirmar Compartir",
  "history.shareSuccess": "Mensaje compartido en la vitrina exitosamente",
  "history.shareFailed": "Error al compartir en la vitrina, por favor inténtalo de nuevo",

  // User Menu
  "userMenu.myAccount": "Mi Cuenta",
  "userMenu.history": "Historial",
  "userMenu.templates": "Plantillas",
  "userMenu.signOut": "Cerrar Sesión",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "Vista previa de respuesta de IA",
  "hero.preview.scenarioLabel": "Escenario",
  "hero.headline": "Asistente de Comunicación con IA",
  "hero.subheadline": "Transforma ideas aproximadas en respuestas pulidas y contextuales en segundos.",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Apertura de ventas",
  "demo.shortTitle.priceObjection": "Sonda de precio",
  "demo.shortTitle.interviewIntro": "Intro de entrevista",
  "demo.shortTitle.emailReply": "Respuesta de correo",
  "demo.shortTitle.followUp": "Seguimiento",
  "demo.shortTitle.elevatorPitch": "Discurso de ascensor",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "respuesta",
  "demoTabs.inputPrompt": "ENTRADA",
  "demoTabs.context": "CONTEXTO",
  "demoTabs.description": "Descripción",
  "demoTabs.generate": "Generar",
  "demoTabs.aiOutput": "SALIDA DE IA",
  "demoTabs.sample": "muestra",
  "demoTabs.streaming": "Transmitiendo tokens...",
  "preview.section.scenarioTemplates.title": "Escenario y Plantillas",
  "preview.section.scenarioTemplates.subtitle": "Elige rápidamente un escenario o aplica una plantilla guardada. Las plantillas rellenan previamente la descripción / destino / tono para que comiences a generar de alta calidad al instante.",
  "preview.section.customInputs.title": "Entradas Personalizadas",
  "preview.section.customInputs.subtitle": "Entrada principal + descripción opcional + selectores avanzados de Escenario / Destino / Tono. Combínalos libremente para obtener resultados contextuales.",
  "preview.section.cutReplyTime.title": "Reducir el Tiempo de Respuesta en un 90%",
  "preview.section.cutReplyTime.subtitle": "Compara la redacción manual vs asistencia de IA. Opciones paralelas + bucles de traducción/revisión integrados.",
  "preview.section.copyShare.title": "Copiar y Compartir con Un Clic",
  "preview.section.copyShare.subtitle": "Múltiples opciones dispuestas con acciones unificadas en la parte superior: copiar todo / compartir / copia por opción. Traducción añadida automáticamente.",
  "preview.templates.my": "Mis Plantillas",
  "preview.templates.new": "Nueva",
  "preview.manualFlow": "Flujo Manual",
  "preview.aiAssisted": "Asistido por IA",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Planificar estructura y tono",
  "preview.manualFlow.step2": "Redactar apertura / borrar y reescribir",
  "preview.manualFlow.step3": "Ajustar cortesía y gramática",
  "preview.manualFlow.step4": "Buscar palabras + verificar traducción",
  "preview.manualFlow.step5": "Pegar en la aplicación de destino",
  "preview.copyAll": "Copiar Todo",
  "preview.share": "Compartir",
  "preview.enPlusTranslation": "EN + Traducción",
  "preview.translationAppendNote": "(*) La traducción se añade automáticamente al copiar todo.",
  "preview.field.scenario": "Escenario",
  "preview.field.target": "Destino",
  "preview.field.tone": "Tono",
  "preview.auto": "Auto",
  "preview.step.pasteOrTemplate": "Pegar solicitud o elegir plantilla",
  "preview.step.optionalDescription": "(Opcional) añadir descripción / escenario",
  "preview.step.pickOption": "Elegir una opción generada",
  "preview.step.copyShareTranslate": "Copiar / compartir / traducir con un clic",
  "preview.time.manual": "5–8 min",
  "preview.time.ai": "30–40 seg"
};